// extracted by mini-css-extract-plugin
module.exports = {"gridGallery":"grid-gallery-module--grid-gallery--R6-uu"};